import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, MutationAction, getModule } from 'vuex-module-decorators';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import AgencyGroupDto from '@/models/AgencyGroups/AgencyGroupDto';
import SkillDto from '@/models/Skills/SkillDto';
import QualificationDto from '@/models/Qualifications/QualificationDto'
import PositionDto from '@/models/Positions/PositionDto';
import UniformDto from '@/models/Uniforms/UniformDto';
import IndustryDto from '@/models/Industries/IndustryDto';
import BranchDto from '@/models/Branches/BranchDto';
import BusinessHoursDto from '@/models/BusinessHours/BusinessHoursDto';
import IntegrationDto from '@/models/Integrations/IntegrationDto';
import FaqCategoryDto from '@/models/FaqCategories/FaqCategoryDto';
import FaqArticleDto from '@/models/FaqArticles/FaqArticleDto';
import DeskDto from '@/models/Desks/DeskDto';
import store from '@/store';
// import UpdateAgencyGeneralDetailsRequest from '@/models/Agencies/UpdateAgencyGeneralDetailsRequest';
// import UpdateAgencyProfileDetailsRequest from '@/models/Agencies/UpdateAgencyProfileDetailsRequest';
import UpdateAgencyUserGeneralDetailsRequest from '@/models/AgencyUsers/UpdateAgencyUserGeneralDetailsRequest';
import UpdateAgencyGroupRequest from '@/models/AgencyGroups/UpdateAgencyGroupRequest';
import CreateSkillRequest from '@/models/Skills/CreateSkillRequest';
import UpdateSkillRequest from '@/models/Skills/UpdateSkillRequest';
import UpdateBusinessHoursRequest from '@/models/BusinessHours/UpdateBusinessHoursRequest';
import UpdateEmailTemplateRequest from '@/models/EmailTemplates/UpdateEmailTemplateRequest';
import UpdateFaqCategoryRequest from '@/models/FaqCategories/UpdateFaqCategoryRequest';
import UpdateFaqArticleRequest from '@/models/FaqArticles/UpdateFaqArticleRequest';
import UpdateConversationTopicRequest from '@/models/ConversationTopics/UpdateConversationTopicRequest';
import CreatePositionRequest from '@/models/Positions/CreatePositionRequest';
import UpdatePositionRequest from '@/models/Positions/UpdatePositionRequest';
import CreateAgencyUserRequest from '@/models/AgencyUsers/CreateAgencyUserRequest';
import CreateAgencyGroupRequest from '@/models/AgencyGroups/CreateAgencyGroupRequest';
import CreateIndustryRequest from '@/models/Industries/CreateIndustryRequest';
import UpdateIndustryRequest from '@/models/Industries/UpdateIndustryRequest';
import { AppModule } from '@/store/modules/app'
import DocumentTemplateDto from '@/models/DocumentTemplates/DocumentTemplateDto';
import UpdateDocumentTemplateHtmlRequest from '@/models/DocumentTemplates/UpdateDocumentTemplateHtmlRequest';
import LocationTypeDto from '@/models/LocationTypes/LocationTypeDto';
import OpportunitySourceDto from '@/models/Opportunities/OpportunitySourceDto';
import OpportunityLostReasonDto from '@/models/Opportunities/OpportunityLostReasonDto';
import ResetAgencyUserPasswordRequest from '@/models/AgencyUsers/ResetAgencyUserPasswordRequest';
import RateCardDto from '@/models/RateCards/RateCardDto';
import CreateRateCardRequest from '@/models/RateCards/CreateRateCardRequest';
import UpdateRateCardRequest from '@/models/RateCards/UpdateRateCardRequest';
import CreateRateCardPositionRequest from '@/models/RateCardPositions/CreateRateCardPositionRequest';
import RateCardPositionDto from '@/models/RateCardPositions/RateCardPositionDto';
import UpdateRateCardPositionRequest from '@/models/RateCardPositions/UpdateRateCardPositionRequest';
import QuestionDto from '@/models/Questions/QuestionDto';
import FormDto from '@/models/Forms/FormDto';
import CreateFormRequest from '@/models/Forms/CreateFormRequest';
import UpdateFormRequest from '@/models/Forms/UpdateFormRequest';
import CreateQuestionRequest from '@/models/Questions/CreateQuestionRequest';
import UpdateQuestionRequest from '@/models/Questions/UpdateQuestionRequest';
import ReorderQuestionsRequest from '@/models/Questions/ReorderQuestionsRequest';
import UpdateAgencyUserStatusRequest from '@/models/AgencyUsers/UpdateAgencyUserStatusRequest';
import CreateBusinesHoursRequest from '@/models/BusinessHours/CreateBusinessHoursRequest';
import CreateEmailTemplateRequest from '@/models/EmailTemplates/CreateEmailTemplateRequest';
import CreateFaqCategoryRequest from '@/models/FaqCategories/CreateFaqCategoryRequest';
import CreateFaqArticleRequest from '@/models/FaqArticles/CreateFaqArticleRequest';
import CreateConversationTopicRequest from '@/models/ConversationTopics/CreateConversationTopicRequest';
import ConversationTopicDto from '@/models/ConversationTopics/ConversationTopicDto';
import AgencyDto from '@/models/Agencies/AgencyDto';
import UpdateAvatarViewModel from '@/models/Avatars/UpdateAvatarViewModel';
import UploadAvatarRequest from '@/models/Avatars/UploadAvatarRequest';
import UpdateAvatarRequest from '@/models/Avatars/UpdateAvatarRequest';
import UpdateAgencyGeneralDetailsRequest from '@/models/Agencies/UpdateAgencyGeneralDetailsRequest';
import UpdateAgencyProfileDetailsRequest from '@/models/Agencies/UpdateAgencyProfileDetailsRequest';
import CreateLocationTypeRequest from '@/models/LocationTypes/CreateLocationTypeRequest';
import UpdateLocationTypeRequest from '@/models/LocationTypes/UpdateLocationTypeRequest';
import CreateOpportunitySourceRequest from '@/models/Opportunities/CreateOpportunitySourceRequest';
import UpdateOpportunitySourceRequest from '@/models/Opportunities/UpdateOpportunitySourceRequest';
import CreateOpportunityLostReasonRequest from '@/models/Opportunities/CreateOpportunityLostReasonRequest';
import UpdateOpportunityLostReasonRequest from '@/models/Opportunities/UpdateOpportunityLostReasonRequest';
import UpdateQualificationRequest from '@/models/Qualifications/UpdateQualificationRequest';
import CreateQualificationRequest from '@/models/Qualifications/CreateQualificationRequest';
import UpdateUniformRequest from '@/models/Uniforms/UpdateUniformRequest';
import CreateUniformRequest from '@/models/Uniforms/CreateUniformRequest';
import UpdateBranchGeneralDetailsRequest from '@/models/Branches/UpdateBranchGeneralDetailsRequest';
import UpdateBranchProfileDetailsRequest from '@/models/Branches/UpdateBranchProfileDetailsRequest';
import UpdateBranchAddressDetailsRequest from '@/models/Branches/UpdateBranchAddressDetailsRequest';
import CreateBranchRequest from '@/models/Branches/CreateBranchRequest';
import UpdateDeskGeneralDetailsRequest from '@/models/Desks/UpdateDeskRequest';
import UpdateDeskExternalAccountingSystemSettingsRequest from '@/models/Desks/UpdateDeskExternalAccountingSystemSettingsRequest';
import UpdateDeskExternalPayrollSystemSettingsRequest from '@/models/Desks/UpdateDeskExternalPayrollSystemSettingsRequest';
import CreateDeskRequest from '@/models/Desks/CreateDeskRequest';
import WorkerBulkInviteSearchRequest from '@/models/Workers/WorkerBulkInviteSearchRequest';
import EmailTemplateDto from '@/models/EmailTemplates/EmailTemplateDto';
import UpdateIntegrationSettingsRequest from '@/models/Integrations/UpdateIntegrationSettingsRequest';
import CreateIntegrationRequest from '@/models/Integrations/CreateIntegrationRequest';
import EmailIntegrationTemplateDto from '@/models/EmailIntegrationTemplates/EmailIntegrationTemplateDto';
import NoteCategoryDto from '@/models/NoteCategories/NoteCategoryDto';
import CreateNoteCategoryRequest from '@/models/NoteCategories/CreateNoteCategoryRequest';
import UpdateNoteCategoryRequest from '@/models/NoteCategories/UpdateNoteCategoryRequest';
import UpdateRichTextRequest from '@/models/Shared/UpdateRichTextRequest';
import ActivityCategoryDto from '@/models/Activities/ActivityCategoryDto';
import AgencyRoleDto from '@/models/AgencyRoles/AgencyRoleDto';
import CreateAgencyRoleRequest from '@/models/AgencyRoles/CreateAgencyRoleRequest';
import UpdateAgencyRoleRequest from '@/models/AgencyRoles/UpdateAgencyRoleRequest';
import ReportingPeriodDto from '@/models/ReportingPeriods/ReportingPeriodDto';
import CreateReportingPeriodRequest from '@/models/ReportingPeriods/CreateReportingPeriodRequest';
import UpdateReportingPeriodRequest from '@/models/ReportingPeriods/UpdateReportingPeriodRequest';
import BulkGenerateReportingPeriodsRequest from '@/models/ReportingPeriods/BulkGenerateReportingPeriodsRequest';

export interface IAgencySettingsState {
  agency: AgencyDto;
  loadingAgency: boolean;
  currentAgencyUser: AgencyUserDto;
  agencyUsers: AgencyUserDto[];
  loadingAgencyUsers: boolean;
  currentAgencyGroup: AgencyGroupDto;
  agencyGroups: AgencyGroupDto[];
  loadingAgencyGroups: boolean;
  currentSkill: SkillDto;
  skills: SkillDto[];
  loadingSkills: boolean;
  currentQualification: QualificationDto;
  qualifications: QualificationDto[];
  loadingQualifications: boolean;
  currentPosition: PositionDto;
  positions: PositionDto[];
  loadingPositions: boolean;
  currentUniform: UniformDto;
  uniforms: UniformDto[];
  loadingUniforms: boolean;
  industries: IndustryDto[];
  loadingIndustries: boolean;
  currentIndustry: IndustryDto;
  locationTypes: LocationTypeDto[];
  loadingLocationTypes: boolean;
  currentLocationType: LocationTypeDto;
  opportunitySources: OpportunitySourceDto[];
  loadingOpportunitySources: boolean;
  currentOpportunitySource: OpportunitySourceDto;
  opportunityLostReasons: OpportunityLostReasonDto[];
  loadingOpportunityLostReasons: boolean;
  currentOpportunityLostReason: OpportunityLostReasonDto;
  rateCards: RateCardDto[];
  loadingRateCards: boolean;
  currentRateCard: RateCardDto;
  forms: FormDto[];
  loadingForms: boolean;
  loadingForm: boolean;
  currentForm: FormDto;
  questions: QuestionDto[];
  loadingQuestions: boolean;
  documentTemplates: DocumentTemplateDto[];
  loadingDocumentTemplates: boolean;
  currentDocumentTemplate: DocumentTemplateDto;
  branches: BranchDto[];
  loadingBranches: boolean;
  currentBranch: BranchDto;
  desks: DeskDto[];
  loadingDesks: boolean;
  currentDesk: DeskDto;
  currentBusinessHours: BusinessHoursDto;
  businessHours: BusinessHoursDto[];
  loadingBusinessHours: boolean;
  currentEmailTemplate: EmailTemplateDto;
  emailTemplates: EmailTemplateDto[];
  loadingEmailTemplates: boolean;
  emailIntegrationTemplates: EmailIntegrationTemplateDto[];
  loadingEmailIntegrationTemplates: boolean;
  loadingIntegration: boolean;
  currentIntegration: IntegrationDto;
  integrations: IntegrationDto[];
  loadingIntegrations: boolean;
  currentNoteCategory: NoteCategoryDto;
  noteCategories: NoteCategoryDto[];
  loadingNoteCategories: boolean;
  currentActivityCategory: ActivityCategoryDto;
  activityCategories: ActivityCategoryDto[];
  loadingActivityCategories: boolean;
  currentFaqCategory: FaqCategoryDto;
  faqCategories: FaqCategoryDto[];
  loadingFaqCategories: boolean;
  currentFaqArticle: FaqArticleDto;
  faqArticles: FaqArticleDto[];
  loadingFaqArticles: boolean;
  currentConversationTopic: ConversationTopicDto;
  conversationTopics: ConversationTopicDto[];
  loadingConversationTopics: boolean;
  loadingDialog: boolean;
  currentAgencyRole: AgencyRoleDto;
  agencyRoles: AgencyRoleDto[];
  loadingAgencyRoles: boolean;
  currentUserAgencyRoles: AgencyRoleDto[];
  currentReportingPeriod: ReportingPeriodDto;
  reportingPeriods: ReportingPeriodDto[];
  loadingReportingPeriods: boolean;
}

@Module({ dynamic: true, store, name: 'AgencySettings', namespaced: true })
class AgencySettings extends VuexModule implements IAgencySettingsState {
 
  public agency: AgencyDto = null;
  public loadingAgency = true;
  public currentAgencyUser: AgencyUserDto = null;
  public agencyUsers: AgencyUserDto[] = [];  
  public loadingAgencyUsers = true;
  public currentAgencyGroup: AgencyGroupDto = null;
  public agencyGroups: AgencyGroupDto[] = [];  
  public loadingAgencyGroups = true;
  public currentSkill: SkillDto = null;
  public skills: SkillDto[] = [];
  public loadingSkills = true;
  public currentQualification: QualificationDto = null;
  public qualifications: QualificationDto[] = [];
  public loadingQualifications = true;
  public currentPosition: PositionDto = null;
  public positions: PositionDto[] = [];
  public loadingPositions = true;
  public currentUniform: UniformDto = null;
  public uniforms: UniformDto[] = [];
  public loadingUniforms = true;
  public currentIndustry: IndustryDto = null;
  public industries: IndustryDto[] = []
  public loadingIndustries = true;
  public locationTypes: LocationTypeDto[] =[];
  public loadingLocationTypes = true;
  public currentLocationType: LocationTypeDto = null;
  public opportunitySources: OpportunitySourceDto[] = [];
  public loadingOpportunitySources = true;
  public currentOpportunitySource: OpportunitySourceDto = null;
  public opportunityLostReasons: OpportunityLostReasonDto[] = [];
  public loadingOpportunityLostReasons = true;
  public currentOpportunityLostReason: OpportunityLostReasonDto = null;
  public rateCards: RateCardDto[] =[];
  public loadingRateCards = true;
  public currentRateCard: RateCardDto = null;
  public forms: FormDto[] =[];
  public loadingForms = true;
  public loadingForm = true;
  public currentForm: FormDto = new FormDto();
  public questions: QuestionDto[] =[];
  public loadingQuestions = true;
  public currentDocumentTemplate: DocumentTemplateDto = new DocumentTemplateDto();
  public documentTemplates: DocumentTemplateDto[] = []
  public loadingDocumentTemplates = true;
  public currentBranch: BranchDto = null;
  public branches: BranchDto[] = [];
  public loadingBranches = true;
  public currentDesk: DeskDto = null;
  public desks: DeskDto[] = [];
  public loadingDesks = true; 
  public currentBusinessHours: BusinessHoursDto = null;
  public businessHours: BusinessHoursDto[] = [];
  public loadingBusinessHours = true; 
  public currentEmailTemplate: EmailTemplateDto = null;
  public emailTemplates: EmailTemplateDto[] = [];
  public loadingEmailTemplates = true; 
  public emailIntegrationTemplates: EmailIntegrationTemplateDto[] = [];
  public loadingEmailIntegrationTemplates = true; 
  public loadingIntegration = true; 
  public currentIntegration: IntegrationDto = null;
  public integrations: IntegrationDto[] = [];
  public loadingIntegrations = true; 
  public currentNoteCategory: NoteCategoryDto = null;
  public noteCategories: NoteCategoryDto[] = [];
  public loadingNoteCategories = true;
  public currentActivityCategory: ActivityCategoryDto = null;
  public activityCategories: ActivityCategoryDto[] = [];
  public loadingActivityCategories = true;
  public currentFaqCategory: FaqCategoryDto = null;
  public faqCategories: FaqCategoryDto[] = [];
  public loadingFaqCategories = true; 
  public currentFaqArticle: FaqArticleDto = null;
  public faqArticles: FaqArticleDto[] = [];
  public loadingFaqArticles = true; 
  public currentConversationTopic: ConversationTopicDto = null;
  public conversationTopics: ConversationTopicDto[] = [];
  public loadingConversationTopics = true;  
  public loadingDialog = false;
  public currentAgencyRole: AgencyRoleDto = null;
  public agencyRoles: AgencyRoleDto[] = [];
  public loadingAgencyRoles = true;
  public currentUserAgencyRoles: AgencyRoleDto[] = [];
  public currentReportingPeriod: ReportingPeriodDto = null;
  public reportingPeriods: ReportingPeriodDto[] = [];
  public loadingReportingPeriods = true;

  @Action
  async getAgency() {
    this.setLoadingAgency(true);
    await ajax.get(`/api/v1/agency`)
    .then(response => {
      this.context.commit("setAgency", response.data);
      this.setLoadingAgency(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingAgency(false);
    });
  }

  @Action
  public async editAgencyGeneralDetails(agency: UpdateAgencyGeneralDetailsRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/general-details`, agency)
    .then(response => {
      this.context.commit("setAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editAgencyProfileDetails(agency: UpdateAgencyProfileDetailsRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/profile-details`, agency)
    .then(response => {
      this.context.commit("setAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editAgencyWorkerDashboardFooter(agency: UpdateRichTextRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/worker-dashboard-footer`, agency)
    .then(response => {
      this.context.commit("setAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }


  @Action
  public async editAgencyWorkerBookingOfferHeader(agency: UpdateRichTextRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/worker-booking-offer-header`, agency)
    .then(response => {
      this.context.commit("setAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editAgencyWorkerBookingOfferFooter(agency: UpdateRichTextRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/worker-booking-offer-footer`, agency)
    .then(response => {
      this.context.commit("setAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editAgencyWorkerBookingConfirmationHeader(agency: UpdateRichTextRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/worker-booking-confirmation-header`, agency)
    .then(response => {
      this.context.commit("setAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editAgencyWorkerBookingConfirmationFooter(agency: UpdateRichTextRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/worker-booking-confirmation-footer`, agency)
    .then(response => {
      this.context.commit("setAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editAgencyWorkerBookingConfirmationCheckboxText(agency: UpdateRichTextRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/worker-booking-confirmation-checkbox-text`, agency)
    .then(response => {
      this.context.commit("setAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editAgencyGeneralHealthAndSafetyInformation(agency: UpdateRichTextRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/general-health-and-safety-information`, agency)
    .then(response => {
      this.context.commit("setAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editAgencyGeneralTrainingInformation(agency: UpdateRichTextRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/general-training-information`, agency)
    .then(response => {
      this.context.commit("setAgency", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }


  @Action
  async editAgencyAvatar(vm: UpdateAvatarViewModel) {
    this.setLoadingDialog(true);
     //First get the signed URL
    const uploadRequest = new UploadAvatarRequest();
    uploadRequest.originFileName = vm.originFileName;
    uploadRequest.contentType = vm.contentType;
    let destinationFileName = '';
    await ajax.post(`/api/v1/agency/avatar/upload`, uploadRequest)
    .then(async uploadResponse => {
      const config = {
        headers: {
          'content-type': vm.contentType,
        }
      };
      destinationFileName = uploadResponse.data.destinationFileName;
      return ajax.put(uploadResponse.data.signedUrl, vm.blobToUpload, config)})
      .then(googleResponse => {
        const updateRequest = new UpdateAvatarRequest();
        updateRequest.fileName = destinationFileName;
        ajax.put(`/api/v1/agency/avatar`, updateRequest)
        .then(response => {
          this.context.commit("setAgency", response.data);
          this.setLoadingDialog(false);
        })
        .catch(error => {
          AppModule.handleApiError(error);
          this.setLoadingDialog(false);
        })
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoadingDialog(false);
      })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getAgencyUsers() {
    this.setLoadingAgencyUsers(true);
    await ajax.get(`/api/v1/agency/users`)
    .then(response => {
      this.context.commit("setAgencyUsers", response.data);
      this.setLoadingAgencyUsers(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingAgencyUsers(false);
    });
  }

  @Action
  public async getAgencyUser(id: string) {
    const user = this.agencyUsers.find((u: AgencyUserDto) => u.id === id);
    if (user) {
      this.context.commit("setCurrentAgencyUser", user);
    }
  }

  @Action
  public async updateCurrentAgencyUser(agencyUser: AgencyUserDto){
    this.context.commit("setCurrentAgencyUser", agencyUser);
  }

  @Action
  async editAgencyUserAvatar(vm: UpdateAvatarViewModel) {
    this.setLoadingDialog(true);
     //First get the signed URL
    const uploadRequest = new UploadAvatarRequest();
    uploadRequest.originFileName = vm.originFileName;
    uploadRequest.contentType = vm.contentType;
    let destinationFileName = '';
    await ajax.post(`/api/v1/agency/users/${this.currentAgencyUser.id}/avatar/upload`, uploadRequest)
    .then(async uploadResponse => {
      const config = {
        headers: {
          'content-type': vm.contentType,
        }
      };
      destinationFileName = uploadResponse.data.destinationFileName;
      return ajax.put(uploadResponse.data.signedUrl, vm.blobToUpload, config)})
      .then(googleResponse => {
        const updateRequest = new UpdateAvatarRequest();
        updateRequest.fileName = destinationFileName;
        ajax.put(`/api/v1/agency/users/${this.currentAgencyUser.id}/avatar`, updateRequest)
        .then(response => {
          this.context.commit("setAgencyUserFromEdit", response.data);
          this.setLoadingDialog(false);
        })
        .catch(error => {
          AppModule.handleApiError(error);
          this.setLoadingDialog(false);
        })
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoadingDialog(false);
      })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  public async editAgencyUserGeneralDetails(request: UpdateAgencyUserGeneralDetailsRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/users/${this.currentAgencyUser.id}/general-details`, request)
    .then(response => {
      this.context.commit("setAgencyUserFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async migrateAgencyUser(userId: string) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/sys/users/${userId}/migrate`)
    .then(response => {
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  public async resetAgencyUserPassword(request: ResetAgencyUserPasswordRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/users/${this.currentAgencyUser.id}/password`, request)
    .then(response => {
      this.context.commit("setAgencyUserFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async deleteAgencyUser(request: UpdateAgencyUserStatusRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/users/${this.currentAgencyUser.id}/status`, request)
    .then(response => {
      this.context.commit("setAgencyUserFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async createAgencyUser(user: CreateAgencyUserRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/users`, user)
    .then(response => {
      this.context.commit("setAgencyUserFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async triggerPasswordReset(id: string) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/users/${id}/trigger-password-reset`)
    .then(response => {
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getAgencyGroups() {
    this.setLoadingAgencyGroups(true);
    await ajax.get(`/api/v1/agency/groups`)
    .then(response => {
      this.context.commit("setAgencyGroups", response.data);
      this.setLoadingAgencyGroups(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingAgencyGroups(false);
    });
  }

  @Action
  public async updateCurrentAgencyGroup(agencyGroup: AgencyGroupDto){
    this.context.commit("setCurrentAgencyGroup", agencyGroup);
  }

  @Action
  public async editAgencyGroup(request: UpdateAgencyGroupRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/groups/${this.currentAgencyGroup.id}`, request)
    .then(response => {
      this.context.commit("setAgencyGroupFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  // @Action
  // public async deleteAgencyGroup(request: UpdateAgencyUserStatusRequest) {
  //   this.setLoadingDialog(true); 
  //   await ajax.put(`/api/v1/agency/users/${this.currentAgencyUser.id}/status`, request)
  //   .then(response => {
  //     this.context.commit("setAgencyUserFromEdit", response.data);
  //     this.setLoadingDialog(false);
  //   })
  //   .catch(error => {
  //     AppModule.handleApiError(error);
  //     this.setLoadingDialog(false);
  //   })
  // }

  @Action
  public async createAgencyGroup(request: CreateAgencyGroupRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/groups`, request)
    .then(response => {
      this.context.commit("setAgencyGroupFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  // =============================================================================
  // Reporting Periods
  // =============================================================================

  @Action
  async getReportingPeriods(fiscalYear?: number) {
    this.setLoadingReportingPeriods(true);
    const params = fiscalYear ? `?fiscalYear=${fiscalYear}` : '';
    await ajax.get(`/api/v1/agency/reporting-periods${params}`)
    .then(response => {
      this.context.commit("setReportingPeriods", response.data);
      this.setLoadingReportingPeriods(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingReportingPeriods(false);
    });
  }

  @Action
  public async updateCurrentReportingPeriod(reportingPeriod: ReportingPeriodDto) {
    this.context.commit("setCurrentReportingPeriod", reportingPeriod);
  }

  @Action
  public async createReportingPeriod(request: CreateReportingPeriodRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/reporting-periods`, request)
    .then(response => {
      this.context.commit("setReportingPeriodFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editReportingPeriod(request: UpdateReportingPeriodRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/reporting-periods/${this.currentReportingPeriod.id}`, request)
    .then(response => {
      this.context.commit("setReportingPeriodFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async deleteReportingPeriod(id: string) {
    this.setLoadingDialog(true);
    await ajax.delete(`/api/v1/agency/reporting-periods/${id}`)
    .then(() => {
      this.context.commit("removeReportingPeriod", id);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async bulkGenerateReportingPeriods(request: BulkGenerateReportingPeriodsRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/reporting-periods/generate`, request)
    .then(response => {
      this.context.commit("setReportingPeriods", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getBusinessHours() {
    this.setLoadingBusinessHours(true);
    await ajax.get(`/api/v1/agency/business-hours`)
    .then(response => {
      this.context.commit("setBusinessHours", response.data);
      this.setLoadingBusinessHours(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingBusinessHours(false);
    });
  }

  @Action
  public async updateCurrentBusinessHours(businessHours: BusinessHoursDto){
    this.context.commit("setCurrentBusinessHours", businessHours);
  }

  @Action
  public async editBusinessHours(request: UpdateBusinessHoursRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/business-hours/${this.currentBusinessHours.id}`, request)
    .then(response => {
      this.context.commit("setBusinessHoursFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async createBusinessHours(request: CreateBusinesHoursRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/business-hours`, request)
    .then(response => {
      this.context.commit("setBusinessHoursFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getEmailTemplates() {
    this.setLoadingEmailTemplates(true);
    await ajax.get(`/api/v1/agency/email-templates`)
    .then(response => {
      this.context.commit("setEmailTemplates", response.data);
      this.setLoadingEmailTemplates(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingEmailTemplates(false);
    });
  }

  @Action
  public async updateCurrentEmailTemplate(emailTemplate: EmailTemplateDto){
    this.context.commit("setCurrentEmailTemplate", emailTemplate);
  }

  @Action
  public async editEmailTemplate(request: UpdateEmailTemplateRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/email-templates/${this.currentEmailTemplate.id}`, request)
    .then(response => {
      this.context.commit("setEmailTemplateFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async createEmailTemplate(request: CreateEmailTemplateRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/email-templates`, request)
    .then(response => {
      this.context.commit("setEmailTemplateFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getEmailIntegrationTemplates() {
    this.setLoadingEmailIntegrationTemplates(true);
    await ajax.get(`/api/v1/agency/email-integration-templates`)
    .then(response => {
      this.context.commit("setEmailIntegrationTemplates", response.data);
      this.setLoadingEmailIntegrationTemplates(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingEmailIntegrationTemplates(false);
    });
  }

  @Action
  async getIntegrations() {
    this.setLoadingIntegrations(true);
    await ajax.get(`/api/v1/agency/integrations`)
    .then(response => {
      this.context.commit("setIntegrations", response.data);
      this.setLoadingIntegrations(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingIntegrations(false);
    });
  }

    @Action
  async getIntegration(integration: IntegrationDto) {
    this.setLoadingIntegrations(true);
    await ajax.get(`/api/v1/agency/integrations/${integration.id}`)
    .then(response => {
      this.context.commit("setCurrentIntegration", response.data);
      this.setLoadingIntegrations(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingIntegrations(false);
    });
  }

  @Action
  public async updateCurrentIntegration(integration: IntegrationDto){
    this.context.commit("setCurrentIntegration", integration);
  }

  @Action
  public async editIntegrationSettings(request: UpdateIntegrationSettingsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/integrations/${this.currentIntegration.id}/settings`, request)
    .then(response => {
      this.context.commit("setIntegrationFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editIntegrationSSOSettings(request: any) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/integrations/${this.currentIntegration.id}/sso-settings`, request)
    .then(response => {
      this.context.commit("setIntegrationFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editIntegrationCapabilities(request: any) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/integrations/${this.currentIntegration.id}/capabilities`, request)
    .then(response => {
      this.context.commit("setIntegrationFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editMicrosoftGoogleSettings(request: any) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/integrations/${this.currentIntegration.id}/microsoft-google-settings`, request)
    .then(response => {
      this.context.commit("setIntegrationFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async createIntegration(request: CreateIntegrationRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/integrations`, request)
    .then(response => {
      this.context.commit("setIntegrationFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async getXeroAuthUrl() {
    try {
      const response = await ajax.get('/api/v1/agency/oauth/xero/authorize');
      return response.data;
    } catch (error) {
      AppModule.handleApiError(error);
      throw error;
    }
  }

  @Action
  public async completeXeroAuth(payload: { code: string; state: string }) {
    try {
      const response = await ajax.post('/api/v1/agency/oauth/xero/token', payload);
      return response.data;
    } catch (error) {
      AppModule.handleApiError(error);
      throw error;
    }
  }

  @Action
  public async getIntegrationById(integrationId: string) {
    if (!integrationId) return null;
    
    this.setLoadingIntegrations(true);
    try {
      const response = await ajax.get(`/api/v1/agency/integrations/${integrationId}`);
      this.context.commit("setCurrentIntegration", response.data);
      return response.data;
    } catch (error) {
      AppModule.handleApiError(error);
    } finally {
      this.setLoadingIntegrations(false);
    }
  }

  @Action
  async getNoteCategories() {
    this.setLoadingNoteCategories(true);
    await ajax.get(`/api/v1/agency/note-categories`)
    .then(response => {
      this.context.commit("setNoteCategories", response.data);
      this.setLoadingNoteCategories(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingNoteCategories(false);
    });
  }

  @Action
  public async updateCurrentNoteCategory(noteCategory: NoteCategoryDto){
    this.context.commit("setCurrentNoteCategory", noteCategory);
  }

  @Action
  public async editNoteCategory(request: UpdateNoteCategoryRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/note-categories/${this.currentNoteCategory.id}`, request)
    .then(response => {
      this.context.commit("setNoteCategoryFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async createNoteCategory(request: CreateNoteCategoryRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/note-categories`, request)
    .then(response => {
      this.context.commit("setNoteCategoryFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getActivityCategories() {
    this.setLoadingActivityCategories(true);
    await ajax.get(`/api/v1/agency/activity-categories`)
    .then(response => {
      this.context.commit("setActivityCategories", response.data);
      this.setLoadingActivityCategories(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingActivityCategories(false);
    });
  }

  @Action
  public async updateCurrentActivityCategory(activityCategory: ActivityCategoryDto){
    this.context.commit("setCurrentActivityCategory", activityCategory);
  }

  @Action
  public async editActivityCategory(request: any) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/activity-categories/${this.currentActivityCategory.id}`, request)
    .then(response => {
      this.context.commit("setActivityCategoryFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async createActivityCategory(request: any) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/activity-categories`, request)
    .then(response => {
      this.context.commit("setActivityCategoryFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getFaqArticles() {
    this.setLoadingFaqArticles(true);
    await ajax.get(`/api/v1/agency/faq-articles`)
    .then(response => {
      this.context.commit("setFaqArticles", response.data);
      this.setLoadingFaqArticles(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingFaqArticles(false);
    });
  }

  @Action
  public async updateCurrentFaqArticle(faqArticle: FaqArticleDto){
    this.context.commit("setCurrentFaqArticle", this.currentFaqArticle);
  }

  @Action
  public async editFaqArticle(request: UpdateFaqArticleRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/faq-articles/${this.currentFaqArticle.id}`, request)
    .then(response => {
      this.context.commit("setFaqArticleFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async createFaqArticle(request: CreateFaqArticleRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/faq-articles`, request)
    .then(response => {
      this.context.commit("setFaqArticleFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getFaqCategories() {
    this.setLoadingFaqCategories(true);
    await ajax.get(`/api/v1/agency/faq-categories`)
    .then(response => {
      this.context.commit("setFaqCategories", response.data);
      this.setLoadingFaqCategories(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingFaqCategories(false);
    });
  }

  @Action
  public async updateCurrentFaqCategory(faqCategory: FaqCategoryDto){
    this.context.commit("setCurrentFaqCategory", faqCategory);
    if (faqCategory != null) {
      this.context.commit("setFaqArticles", faqCategory.faqArticles);
    } else {
      this.context.commit("setFaqArticles", []);
    }

    
  }

  @Action
  public async editFaqCategory(request: UpdateFaqCategoryRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/faq-categories/${this.currentFaqCategory.id}`, request)
    .then(response => {
      this.context.commit("setFaqCategoryFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async createFaqCategory(request: CreateFaqCategoryRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/faq-categories`, request)
    .then(response => {
      this.context.commit("setFaqCategoryFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getConversationTopics() {
    this.setLoadingConversationTopics(true);
    await ajax.get(`/api/v1/agency/conversation-topics`)
    .then(response => {
      this.context.commit("setConversationTopics", response.data);
      this.setLoadingConversationTopics(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingConversationTopics(false);
    });
  }

  @Action
  public async updateCurrentConversationTopic(conversationTopic: ConversationTopicDto){
    this.context.commit("setCurrentConversationTopic", conversationTopic);
  }

  @Action
  public async editConversationTopic(request: UpdateConversationTopicRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/conversation-topics/${this.currentConversationTopic.id}`, request)
    .then(response => {
      this.context.commit("setConversationTopicFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async createConversationTopic(request: CreateConversationTopicRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/conversation-topics`, request)
    .then(response => {
      this.context.commit("setConversationTopicFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }



  @Action
  async getSkills() {
    this.setLoadingSkills(true);
    await ajax.get(`/api/v1/agency/skills`)
    .then(response => {
      this.context.commit("setSkills", response.data);
      this.setLoadingSkills(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingSkills(false);
    });
  }

  @Action
  public async updateCurrentSkill(agencySkill: SkillDto){
    this.context.commit("setCurrentSkill", agencySkill);
  }

  @Action
  public async createSkill(request: CreateSkillRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/skills`, request)
    .then(response => {
      this.context.commit("setSkillFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editSkill(request: UpdateSkillRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/skills/${this.currentSkill.id}`, request)
    .then(response => {
      this.context.commit("setSkillFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getAgencyRoles() {
    this.setLoadingAgencyRoles(true);
    await ajax.get(`/api/v1/agency/roles`)
    .then(response => {
      this.context.commit("setAgencyRoles", response.data);
      this.setLoadingAgencyRoles(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingAgencyRoles(false);
    });
  }

  @Action
  public async updateCurrentAgencyRole(agencyRole: AgencyRoleDto){
    this.context.commit("setCurrentAgencyRole", agencyRole);
  }

  @Action
  public async createAgencyRole(request: CreateAgencyRoleRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/roles`, request)
    .then(response => {
      this.context.commit("setAgencyRoleFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editAgencyRole(request: UpdateAgencyRoleRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/roles/${this.currentAgencyRole.id}`, request)
    .then(response => {
      this.context.commit("setAgencyRoleFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async deleteAgencyRole(request: any) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/roles/${this.currentAgencyRole.id}/status`, request)
    .then(response => {
      this.context.commit("setAgencyRoleFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async getAgencyRolesForUser(agencyUserId: string) {
    await ajax.get(`/api/v1/agency/users/${agencyUserId}/roles`)
    .then(response => {
      this.context.commit("setCurrentUserAgencyRoles", response.data);
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  public async setAgencyRolesForUser(payload: { agencyUserId: string; roleIds: string[] }) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/users/${payload.agencyUserId}/roles`, { roleIds: payload.roleIds })
    .then(response => {
      this.context.commit("setCurrentUserAgencyRoles", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getQualifications() {
    this.setLoadingQualifications(true);
    await ajax.get(`/api/v1/agency/qualifications`)
    .then(response => {
      this.context.commit("setQualifications", response.data);
      this.setLoadingQualifications(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingQualifications(false);
    });
  }

  @Action
  public async updateCurrentQualification(agencyQualification: QualificationDto){
    this.context.commit("setCurrentQualification", agencyQualification);
  }

  @Action
  public async createQualification(request: CreateQualificationRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/qualifications`, request)
    .then(response => {
      this.context.commit("setQualificationFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editQualification(request: UpdateQualificationRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/qualifications/${this.currentQualification.id}`, request)
    .then(response => {
      this.context.commit("setQualificationFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getBranches() {
    this.setLoadingBranches(true);
    await ajax.get(`/api/v1/agency/branches`)
    .then(response => {
      this.context.commit("setBranches", response.data);
      this.setLoadingBranches(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingBranches(false);
    });
  }

  @Action
  public async updateCurrentBranch(branch: BranchDto){
    this.context.commit("setCurrentBranch", branch);
  }

  @Action
  public async createBranch(request: CreateBranchRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/branches`, request)
    .then(response => {
      this.context.commit("setBranchFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editBranchGeneralDetails(request: UpdateBranchGeneralDetailsRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/branches/${this.currentBranch.id}/general-details`, request)
    .then(response => {
      this.context.commit("setBranchFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editBranchProfileDetails(request: UpdateBranchProfileDetailsRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/branches/${this.currentBranch.id}/profile-details`, request)
    .then(response => {
      this.context.commit("setBranchFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editBranchAddressDetails(request: UpdateBranchAddressDetailsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/branches/${this.currentBranch.id}/address-details`, request)
    .then(response => {
      this.context.commit("setBranchFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async updateCurrentDesk(desk: DeskDto){
    this.context.commit("setCurrentDesk", desk);
  }

  @Action
  public async createDesk(request: CreateDeskRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/branches/${this.currentBranch.id}/desks`, request)
    .then(response => {
      this.context.commit("setDeskFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editDeskGeneralDetails(request: UpdateDeskGeneralDetailsRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/branches/${this.currentBranch.id}/desks/${this.currentDesk.id}/general-details`, request)
    .then(response => {
      this.context.commit("setDeskFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editDeskExternalAccountingSystemSettings(request: UpdateDeskExternalAccountingSystemSettingsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/branches/${this.currentBranch.id}/desks/${this.currentDesk.id}/external-accounting-system-settings`, request)
    .then(response => {
      this.context.commit("setDeskFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editDeskExternalPayrollSystemSettings(request: UpdateDeskExternalPayrollSystemSettingsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/branches/${this.currentBranch.id}/desks/${this.currentDesk.id}/external-payroll-system-settings`, request)
    .then(response => {
      this.context.commit("setDeskFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async deskBulkInviteWorkers(request: WorkerBulkInviteSearchRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/workers/bulk-invite`, request)
    .then(response => {
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getPositions() {
    this.setLoadingPositions(true);
    await ajax.get(`/api/v1/agency/positions`)
    .then(response => {
      this.context.commit("setPositions", response.data);
      this.setLoadingPositions(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingPositions(false);
    });
  }

  @Action
  public async updateCurrentPosition(agencyPosition: PositionDto){
    this.context.commit("setCurrentPosition", agencyPosition);
  }

  @Action
  public async createPosition(request: CreatePositionRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/positions`, request)
    .then(response => {
      this.context.commit("setPositionFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editPosition(position: UpdatePositionRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/positions/${this.currentPosition.id}`, position)
    .then(response => {
      this.context.commit("setPositionFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getUniforms() {
    this.setLoadingUniforms(true);
    await ajax.get(`/api/v1/agency/uniforms`)
    .then(response => {
      this.context.commit("setUniforms", response.data);
      this.setLoadingUniforms(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingUniforms(false);
    });
  }

  @Action
  public async updateCurrentUniform(agencyUniform: UniformDto){
    this.context.commit("setCurrentUniform", agencyUniform);
  }

  @Action
  public async createUniform(request: CreateUniformRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/uniforms`, request)
    .then(response => {
      this.context.commit("setUniformFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editUniform(request: UpdateUniformRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/uniforms/${this.currentUniform.id}`, request)
    .then(response => {
      this.context.commit("setUniformFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getIndustries() {
    this.setLoadingIndustries(true);
    await ajax.get(`/api/v1/agency/industries`)
    .then(response => {
      this.context.commit("setIndustries", response.data);
      this.setLoadingIndustries(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingIndustries(false);
    });
  }

  @Action
  public async updateCurrentIndustry(industry: IndustryDto){
    this.context.commit("setCurrentIndustry", industry);
  }

  @Action
  public async createIndustry(request: CreateIndustryRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/industries`, request)
    .then(response => {
      this.context.commit("setIndustryFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editIndustry(request: UpdateIndustryRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/industries/${this.currentIndustry.id}`, request)
    .then(response => {
      this.context.commit("setIndustryFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getLocationTypes() {
    this.setLoadingLocationTypes(true);
    await ajax.get(`/api/v1/agency/location-types`)
    .then(response => {
      this.context.commit("setLocationTypes", response.data);
      this.setLoadingLocationTypes(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingLocationTypes(false);
    });
  }

  @Action
  public async updateCurrentLocationType(locationType: LocationTypeDto){
    this.context.commit("setCurrentLocationType", locationType);
  }

  @Action
  public async createLocationType(request: CreateLocationTypeRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/location-types`, request)
    .then(response => {
      this.context.commit("setLocationTypeFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editLocationType(request: UpdateLocationTypeRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/location-types/${this.currentLocationType.id}`, request)
    .then(response => {
      this.context.commit("setLocationTypeFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async deleteLocationType(locationType: LocationTypeDto) {
    this.setLoadingDialog(true);
    await ajax.delete(`/api/v1/agency/location-types/${locationType.id}`)
    .then(response => {
      this.context.commit("setLocationTypeFromDelete");
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getOpportunitySources() {
    this.setLoadingOpportunitySources(true);
    await ajax.get(`/api/v1/agency/opportunity-sources`)
    .then(response => {
      this.context.commit("setOpportunitySources", response.data);
      this.setLoadingOpportunitySources(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingOpportunitySources(false);
    });
  }

  @Action
  public async updateCurrentOpportunitySource(opportunitySource: OpportunitySourceDto) {
    this.context.commit("setCurrentOpportunitySource", opportunitySource);
  }

  @Action
  public async createOpportunitySource(request: CreateOpportunitySourceRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/opportunity-sources`, request)
    .then(response => {
      this.context.commit("setOpportunitySourceFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editOpportunitySource(request: UpdateOpportunitySourceRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/opportunity-sources/${this.currentOpportunitySource.id}`, request)
    .then(response => {
      this.context.commit("setOpportunitySourceFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async deleteOpportunitySource(opportunitySource: OpportunitySourceDto) {
    this.setLoadingDialog(true);
    await ajax.delete(`/api/v1/agency/opportunity-sources/${opportunitySource.id}`)
    .then(response => {
      this.context.commit("setOpportunitySourceFromDelete");
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getOpportunityLostReasons() {
    this.setLoadingOpportunityLostReasons(true);
    await ajax.get(`/api/v1/agency/opportunity-lost-reasons`)
    .then(response => {
      this.context.commit("setOpportunityLostReasons", response.data);
      this.setLoadingOpportunityLostReasons(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingOpportunityLostReasons(false);
    });
  }

  @Action
  public async updateCurrentOpportunityLostReason(opportunityLostReason: OpportunityLostReasonDto) {
    this.context.commit("setCurrentOpportunityLostReason", opportunityLostReason);
  }

  @Action
  public async createOpportunityLostReason(request: CreateOpportunityLostReasonRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/opportunity-lost-reasons`, request)
    .then(response => {
      this.context.commit("setOpportunityLostReasonFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editOpportunityLostReason(request: UpdateOpportunityLostReasonRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/opportunity-lost-reasons/${this.currentOpportunityLostReason.id}`, request)
    .then(response => {
      this.context.commit("setOpportunityLostReasonFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async deleteOpportunityLostReason(opportunityLostReason: OpportunityLostReasonDto) {
    this.setLoadingDialog(true);
    await ajax.delete(`/api/v1/agency/opportunity-lost-reasons/${opportunityLostReason.id}`)
    .then(response => {
      this.context.commit("setOpportunityLostReasonFromDelete");
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async createRateCard(request: CreateRateCardRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/rate-cards`, request)
    .then(response => {
      this.context.commit("setRateCardFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editRateCard(request: UpdateRateCardRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/rate-cards/${this.currentRateCard.id}`, request)
    .then(response => {
      this.context.commit("setRateCardFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getRateCards() {
    this.setLoadingRateCards(true);
    await ajax.get(`/api/v1/agency/rate-cards`)
    .then(response => {
      this.context.commit("setRateCards", response.data);
      this.setLoadingRateCards(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingRateCards(false);
    });
  }

  @Action
  public async updateCurrentRateCard(rateCard: RateCardDto){
    this.context.commit("setCurrentRateCard", rateCard);
  }

  @Action
  public async createRateCardPosition(request: CreateRateCardPositionRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/rate-cards/${this.currentRateCard.id}/positions`, request)
    .then(response => {
      this.context.commit("setRateCardPositionFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editRateCardPosition(rateCardPosition: RateCardPositionDto) {
    this.setLoadingDialog(true); 
    const request = new UpdateRateCardPositionRequest();
    request.updatedAt = rateCardPosition.updatedAt;
    request.chargeRate = rateCardPosition.chargeRate;
    await ajax.put(`/api/v1/agency/rate-cards/${this.currentRateCard.id}/positions/${rateCardPosition.id}`, request)
    .then(response => {
      this.context.commit("setRateCardPositionFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action 
  async deleteRateCardPosition(rateCardPosition: RateCardPositionDto) {
    //this.setLoading(true);
    await ajax.delete(`/api/v1/agency/rate-cards/${this.currentRateCard.id}/positions/${rateCardPosition.id}`)
    .then(response => {
      this.context.commit("removeRateCardPositionFromDelete", rateCardPosition);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }

  @Action
  public async createForm(request: CreateFormRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/forms`, request)
    .then(response => {
      this.context.commit("setFormFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editForm(request: UpdateFormRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/forms/${this.currentForm.id}`, request)
    .then(response => {
      this.context.commit("setFormFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async getForms() {
    this.setLoadingForms(true);
    await ajax.get(`/api/v1/agency/forms`)
    .then(response => {
      this.context.commit("setForms", response.data);
      this.setLoadingForms(false);
      if (this.forms && this.forms.length > 0) {
        //Load the first one
        this.getForm(this.forms[0]);
      }
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingForms(false);
    });
  }

  @Action
  public async getForm(form: FormDto){ 
    this.setLoadingForm(true);
    await ajax.get(`/api/v1/agency/forms/${form.id}`)
    .then(response => {
      this.context.commit("setCurrentForm", response.data);
      this.setLoadingForm(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingForm(false);
    });
  }

  @Action
  public async createQuestion(request: CreateQuestionRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/forms/${this.currentForm.id}/questions`, request)
    .then(response => {
      this.context.commit("setQuestionFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async editQuestion(request: UpdateQuestionRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/forms/${this.currentForm.id}/questions/${request.id}`, request)
    .then(response => {
      this.context.commit("setQuestionFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async reorderQuestions(request: ReorderQuestionsRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/forms/${this.currentForm.id}/re-order-questions`, request)
    .then(response => {
      this.context.commit("setFormFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getDocumentTemplates() {
    this.setLoadingDocumentTemplates(true);
    await ajax.get(`/api/v1/agency/doc-templates`)
    .then(response => {
      this.context.commit("setDocumentTemplates", response.data);
      this.setLoadingDocumentTemplates(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDocumentTemplates(false);
    });
  }

  @Action
  public async updateCurrentDocumentTemplate(documentTemplate: DocumentTemplateDto){
    this.context.commit("setCurrentDocumentTemplate", documentTemplate);
  }

  @Action
  public async editDocumentTemplateHtml(documentTemplateHtml: UpdateDocumentTemplateHtmlRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/doc-templates/${this.currentDocumentTemplate.id}/html`, documentTemplateHtml)
    .then(response => {
      this.context.commit("setDocumentTemplateHtmlFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  @Mutation
  resetState() {
    this.agency = null;
    this.currentAgencyUser = null;
    this.currentAgencyGroup = null;
    this.currentSkill = null;
    this.currentQualification = null;
    this.currentPosition = null;
    this.currentIndustry = null;
    this.currentLocationType = null;
    this.currentOpportunitySource = null;
    this.currentOpportunityLostReason = null;
    this.currentDocumentTemplate = new DocumentTemplateDto();
    this.currentUniform = null;
    this.currentBranch = null;  
    this.currentDesk = null;  
    this.currentBusinessHours = null;
    this.currentEmailTemplate = null;
    this.currentIntegration = null;
    this.currentNoteCategory = null;
    this.currentFaqCategory = null;
    this.currentFaqArticle = null;
    this.currentConversationTopic = null;
    this.currentRateCard = null;
    this.currentForm = new FormDto();
    this.currentReportingPeriod = null;

    this.agencyUsers = [];
    this.agencyGroups = [];
    this.skills = [];
    this.qualifications = [];
    this.positions = [];
    this.desks = [];
    this.industries = [];
    this.locationTypes = [];
    this.opportunitySources = [];
    this.opportunityLostReasons = [];
    this.documentTemplates = [];
    this.uniforms = [];
    this.branches = [];
    this.businessHours = [];
    this.emailTemplates = [];
    this.emailIntegrationTemplates = [];
    this.integrations = [];
    this.noteCategories = [];
    this.faqCategories = [];
    this.faqArticles = [];
    this.conversationTopics = [];
    this.rateCards = [];
    this.forms = [];
    this.questions = [];
    this.reportingPeriods = [];

    this.loadingAgency = true;
    this.loadingAgencyUsers = true;
    this.loadingAgencyGroups = true;
    this.loadingSkills = true;
    this.loadingQualifications = true;
    this.loadingPositions = true;
    this.loadingUniforms = true;
    this.loadingIndustries = true;
    this.loadingLocationTypes = true;
    this.loadingOpportunitySources = true;
    this.loadingOpportunityLostReasons = true;
    this.loadingDocumentTemplates = true;
    this.loadingConversationTopics = true;
    this.loadingBranches = true;
    this.loadingDesks = true;
    this.loadingBusinessHours = true;
    this.loadingEmailTemplates = true;
    this.loadingEmailIntegrationTemplates = true;
    this.loadingIntegrations = true;
    this.loadingNoteCategories = true;
    this.loadingFaqCategories = true;
    this.loadingFaqArticles = true;
    this.loadingRateCards = true;
    this.loadingForms = true;
    this.loadingQuestions = true;
    this.loadingReportingPeriods = true;
  }

  @Mutation
  private async setLoadingDialog(isLoading: boolean) {
      this.loadingDialog = isLoading;
  }

  @Mutation
  private async setLoadingAgency(isLoading: boolean) {
      this.loadingAgency = isLoading;
  }

  @Mutation
  private async setAgency(agency: AgencyDto) {
      this.agency = agency;
  }

  @Mutation
  private async setLoadingAgencyUsers(isLoading: boolean) {
      this.loadingAgencyUsers = isLoading;
  }

  @Mutation
  private async setAgencyUsers(agencyUsers: AgencyUserDto[]) {
      this.agencyUsers = agencyUsers;
  }
  
  @Mutation
  private async setCurrentAgencyUser(agencyUser: AgencyUserDto) {
      this.currentAgencyUser = agencyUser;
  }

  @Mutation
  private async setAgencyUserFromEdit(agencyUser: AgencyUserDto) {
    this.currentAgencyUser = agencyUser;
    const index = this.agencyUsers.findIndex((findUser: AgencyUserDto) => agencyUser.id === findUser.id);
    this.agencyUsers[index] = agencyUser;
  }

  @Mutation
  private async setAgencyUserFromCreate(agencyUser: AgencyUserDto) {
    this.agencyUsers.push(agencyUser);
  }

  @Mutation
  private async setLoadingAgencyGroups(isLoading: boolean) {
      this.loadingAgencyGroups = isLoading;
  }
  
  @Mutation
  private async setAgencyGroups(agencyGroups: AgencyGroupDto[]) {
      this.agencyGroups = agencyGroups;
  }
  
  @Mutation
  private async setCurrentAgencyGroup(agencyGroup: AgencyGroupDto) {
      this.currentAgencyGroup = agencyGroup;
  }

  @Mutation
  private async setAgencyGroupFromEdit(agencyGroup: AgencyGroupDto) {
    this.currentAgencyGroup = agencyGroup;
    const index = this.agencyGroups.findIndex((findGroup: AgencyGroupDto) => agencyGroup.id === findGroup.id);
    this.agencyGroups[index] = agencyGroup;
  }

  @Mutation
  private async setAgencyGroupFromCreate(agencyGroup: AgencyGroupDto) {
    this.agencyGroups.push(agencyGroup);
  }

  @Mutation
  private async setLoadingReportingPeriods(isLoading: boolean) {
      this.loadingReportingPeriods = isLoading;
  }

  @Mutation
  private async setReportingPeriods(reportingPeriods: ReportingPeriodDto[]) {
      this.reportingPeriods = reportingPeriods;
  }

  @Mutation
  private async setCurrentReportingPeriod(reportingPeriod: ReportingPeriodDto) {
      this.currentReportingPeriod = reportingPeriod;
  }

  @Mutation
  private async setReportingPeriodFromEdit(reportingPeriod: ReportingPeriodDto) {
    this.currentReportingPeriod = reportingPeriod;
    const index = this.reportingPeriods.findIndex((rp: ReportingPeriodDto) => reportingPeriod.id === rp.id);
    if (index >= 0) this.reportingPeriods[index] = reportingPeriod;
  }

  @Mutation
  private async setReportingPeriodFromCreate(reportingPeriod: ReportingPeriodDto) {
    this.reportingPeriods.push(reportingPeriod);
  }

  @Mutation
  private async removeReportingPeriod(id: string) {
    this.reportingPeriods = this.reportingPeriods.filter((rp: ReportingPeriodDto) => rp.id !== id);
    if (this.currentReportingPeriod && this.currentReportingPeriod.id === id) {
      this.currentReportingPeriod = null;
    }
  }

  @Mutation
  private async setLoadingBusinessHours(isLoading: boolean) {
      this.loadingBusinessHours = isLoading;
  }
  
  @Mutation
  private async setBusinessHours(businessHours: BusinessHoursDto[]) {
      this.businessHours = businessHours;
  }
  
  @Mutation
  private async setCurrentBusinessHours(businessHours: BusinessHoursDto) {
      this.currentBusinessHours = businessHours;
  }

  @Mutation
  private async setBusinessHoursFromEdit(businessHours: BusinessHoursDto) {
    this.currentBusinessHours = businessHours;
    const index = this.businessHours.findIndex((findBusinessHours: BusinessHoursDto) => businessHours.id === findBusinessHours.id);
    this.businessHours[index] = businessHours;
  }

  @Mutation
  private async setBusinessHoursFromCreate(businessHours: BusinessHoursDto) {
    this.businessHours.push(businessHours);
  }

  @Mutation
  private async setLoadingEmailTemplates(isLoading: boolean) {
      this.loadingEmailTemplates = isLoading;
  }

  @Mutation
  private async setEmailTemplates(emailTemplates: EmailTemplateDto[]) {
      this.emailTemplates = emailTemplates;
  }

  @Mutation
  private async setLoadingEmailIntegrationTemplates(isLoading: boolean) {
      this.loadingEmailIntegrationTemplates = isLoading;
  }
  
  @Mutation
  private async setEmailIntegrationTemplates(emailIntegrationTemplates: EmailIntegrationTemplateDto[]) {
      this.emailIntegrationTemplates = emailIntegrationTemplates;
  }
  
  @Mutation
  private async setCurrentEmailTemplate(emailTemplate: EmailTemplateDto) {
      this.currentEmailTemplate = emailTemplate;
  }

  @Mutation
  private async setEmailTemplateFromEdit(emailTemplate: EmailTemplateDto) {
    this.currentEmailTemplate = emailTemplate;
    const index = this.emailTemplates.findIndex((findEmailTemplate: EmailTemplateDto) => emailTemplate.id === findEmailTemplate.id);
    this.emailTemplates[index] = emailTemplate;
  }

  @Mutation
  private async setEmailTemplateFromCreate(emailTemplate: EmailTemplateDto) {
    this.emailTemplates.push(emailTemplate);
  }

  @Mutation
  private async setLoadingIntegrations(isLoading: boolean) {
      this.loadingIntegrations = isLoading;
  }
  
  @Mutation
  private async setIntegrations(integrations: IntegrationDto[]) {
      this.integrations = integrations;
  }
  
  @Mutation
  private async setCurrentIntegration(integration: IntegrationDto) {
      this.currentIntegration = integration;
  }

  @Mutation
  private async setIntegrationFromEdit(integration: IntegrationDto) {
    this.currentIntegration = integration;
    const index = this.integrations.findIndex((findIntegration: IntegrationDto) => integration.id === findIntegration.id);
    this.integrations[index] = integration;
  }

  @Mutation
  private async setIntegrationFromCreate(integration: IntegrationDto) {
    this.integrations.push(integration);
  }



  @Mutation
  private async setLoadingNoteCategories(isLoading: boolean) {
      this.loadingNoteCategories = isLoading;
  }

  @Mutation
  private async setNoteCategories(noteCategories: NoteCategoryDto[]) {
      this.noteCategories = noteCategories;
  }
    
  @Mutation
  private async setCurrentNoteCategory(noteCategory: NoteCategoryDto) {
      this.currentNoteCategory = noteCategory;
  }

  @Mutation
  private async setNoteCategoryFromEdit(noteCategory: NoteCategoryDto) {
    this.currentNoteCategory = noteCategory;
    const index = this.noteCategories.findIndex((findNoteCategory: NoteCategoryDto) => noteCategory.id === findNoteCategory.id);
    this.noteCategories[index] = noteCategory;
  }

  @Mutation
  private async setNoteCategoryFromCreate(noteCategory: NoteCategoryDto) {
    this.noteCategories.push(noteCategory);
  }

  @Mutation
  private async setLoadingActivityCategories(isLoading: boolean) {
      this.loadingActivityCategories = isLoading;
  }

  @Mutation
  private async setActivityCategories(activityCategories: ActivityCategoryDto[]) {
      this.activityCategories = activityCategories;
  }

  @Mutation
  private async setCurrentActivityCategory(activityCategory: ActivityCategoryDto) {
      this.currentActivityCategory = activityCategory;
  }

  @Mutation
  private async setActivityCategoryFromEdit(activityCategory: ActivityCategoryDto) {
    this.currentActivityCategory = activityCategory;
    const index = this.activityCategories.findIndex((findActivityCategory: ActivityCategoryDto) => activityCategory.id === findActivityCategory.id);
    this.activityCategories[index] = activityCategory;
  }

  @Mutation
  private async setActivityCategoryFromCreate(activityCategory: ActivityCategoryDto) {
    this.activityCategories.push(activityCategory);
  }

  @Mutation
  private async setLoadingFaqArticles(isLoading: boolean) {
      this.loadingFaqArticles = isLoading;
  }
  
  @Mutation
  private async setFaqArticles(faqArticles: FaqArticleDto[]) {
      this.faqArticles = faqArticles;
  }
  
  @Mutation
  private async setCurrentFaqArticle(faqArticle: FaqArticleDto) {
      this.currentFaqArticle = faqArticle;
  }

  @Mutation
  private async setFaqArticleFromEdit(faqArticle: FaqArticleDto) {
    this.currentFaqArticle = faqArticle;
    const index = this.faqArticles.findIndex((findFaqArticle: FaqArticleDto) => faqArticle.id === findFaqArticle.id);
    this.faqArticles[index] = faqArticle;
  }

  @Mutation
  private async setFaqArticleFromCreate(faqArticle: FaqArticleDto) {
    this.faqArticles.push(faqArticle);
  }

  @Mutation
  private async setLoadingFaqCategories(isLoading: boolean) {
      this.loadingFaqCategories = isLoading;
  }
  
  @Mutation
  private async setFaqCategories(faqCategories: FaqCategoryDto[]) {
      this.faqCategories = faqCategories;
  }
  
  @Mutation
  private async setCurrentFaqCategory(faqCategory: FaqCategoryDto) {
      this.currentFaqCategory = faqCategory;
  }

  @Mutation
  private async setFaqCategoryFromEdit(faqCategory: FaqCategoryDto) {
    this.currentFaqCategory = faqCategory;
    const index = this.faqCategories.findIndex((findFaqCategory: FaqCategoryDto) => faqCategory.id === findFaqCategory.id);
    this.faqCategories[index] = faqCategory;
  }

  @Mutation
  private async setFaqCategoryFromCreate(faqCategory: FaqCategoryDto) {
    this.faqCategories.push(faqCategory);
  }

  @Mutation
  private async setLoadingConversationTopics(isLoading: boolean) {
      this.loadingConversationTopics = isLoading;
  }
  
  @Mutation
  private async setConversationTopics(conversationTopics: ConversationTopicDto[]) {
      this.conversationTopics = conversationTopics;
  }
  
  @Mutation
  private async setCurrentConversationTopic(conversationTopic: ConversationTopicDto) {
      this.currentConversationTopic = conversationTopic;
  }

  @Mutation
  private async setConversationTopicFromEdit(conversationTopic: ConversationTopicDto) {
    this.currentConversationTopic = conversationTopic;
    const index = this.conversationTopics.findIndex((findConversationTopic: ConversationTopicDto) => conversationTopic.id === findConversationTopic.id);
    this.conversationTopics[index] = conversationTopic;
  }

  @Mutation
  private async setConversationTopicFromCreate(conversationTopic: ConversationTopicDto) {
    this.conversationTopics.push(conversationTopic);
  }

  @Mutation
  private async setLoadingSkills(isLoadingSkills: boolean) {
      this.loadingSkills = isLoadingSkills;
  }

  @Mutation
  private async setSkills(skills: SkillDto[]) {
      this.skills = skills;
  }
  
  @Mutation
  private async setCurrentSkill(skill: SkillDto) {
      this.currentSkill = skill;
  }

  @Mutation
  private async setSkillFromEdit(skill: SkillDto) {
   this.currentSkill = skill;
   const index = this.skills.findIndex((findSkill: SkillDto) => skill.id === findSkill.id);
   this.skills.splice(index, 1, skill);
  }

  @Mutation
  private async setSkillFromCreate(skill: SkillDto) {
    this.skills.push(skill);
  }

  @Mutation
  private async setLoadingAgencyRoles(isLoading: boolean) {
      this.loadingAgencyRoles = isLoading;
  }

  @Mutation
  private async setAgencyRoles(roles: AgencyRoleDto[]) {
      this.agencyRoles = roles;
  }

  @Mutation
  private async setCurrentAgencyRole(role: AgencyRoleDto) {
      this.currentAgencyRole = role;
  }

  @Mutation
  private async setAgencyRoleFromEdit(role: AgencyRoleDto) {
    this.currentAgencyRole = role;
    const index = this.agencyRoles.findIndex((r: AgencyRoleDto) => role.id === r.id);
    this.agencyRoles.splice(index, 1, role);
  }

  @Mutation
  private async setAgencyRoleFromCreate(role: AgencyRoleDto) {
    this.agencyRoles.push(role);
  }

  @Mutation
  private async setCurrentUserAgencyRoles(roles: AgencyRoleDto[]) {
    this.currentUserAgencyRoles = roles;
  }

  @Mutation
  private async setLoadingQualifications(isLoadingQualifications: boolean) {
      this.loadingQualifications = isLoadingQualifications;
  }

  @Mutation
  private async setQualifications(qualifications: QualificationDto[]) {
      this.qualifications = qualifications;
  }
  
  @Mutation
  private async setCurrentQualification(qualification: QualificationDto) {
    this.currentQualification = qualification;
  }

  @Mutation
  private async setQualificationFromEdit(qualification: QualificationDto) {
   this.currentQualification = qualification;
   const index = this.qualifications.findIndex((findQualification: QualificationDto) => qualification.id === findQualification.id);
   this.qualifications.splice(index, 1, qualification);
  }

  @Mutation
  private async setQualificationFromCreate(qualification: QualificationDto) {
    this.qualifications.push(qualification);
  }

  @Mutation
  private async setLoadingPositions(isLoadingPositions: boolean) {
    this.loadingPositions = isLoadingPositions;
  }

  @Mutation
  private async setPositions(positions: PositionDto[]) {
    this.positions = positions;
  }
  
  @Mutation
  private async setCurrentPosition(position: PositionDto) {
      this.currentPosition = position;
  }

  @Mutation
  private async setPositionFromEdit(position: PositionDto) {
   this.currentPosition = position;
   const index = this.positions.findIndex((findPosition: PositionDto) => position.id === findPosition.id);
   this.positions.splice(index, 1, position);
  }

  @Mutation
  private async setPositionFromCreate(position: PositionDto) {
    this.positions.push(position);
  }

  @Mutation
  private async setLoadingUniforms(isLoadingUniforms: boolean) {
      this.loadingUniforms = isLoadingUniforms;
  }

  @Mutation
  private async setUniforms(uniforms: UniformDto[]) {
      this.uniforms = uniforms;
      if (uniforms && uniforms.length > 0) {
        this.currentUniform = this.uniforms[0];
      }
  }
  
  @Mutation
  private async setCurrentUniform(uniform: UniformDto) {
      this.currentUniform = uniform;
  }

  @Mutation
  private async setUniformFromEdit(uniform: UniformDto) {
   this.currentUniform = uniform;
   const index = this.uniforms.findIndex((findUniform: UniformDto) => uniform.id === findUniform.id);
   this.uniforms.splice(index, 1, uniform);
  }

  @Mutation
  private async setUniformFromCreate(uniform: UniformDto) {
    this.uniforms.push(uniform);
  }

  @Mutation
  private async setLoadingBranches(isLoadingBranches: boolean) {
      this.loadingBranches = isLoadingBranches;
  }

  @Mutation
  private async setBranches(branches: BranchDto[]) {
      branches.forEach(branch => {
        branch.name = branch.brandName;
        branch.isBranch = true;
      });
      this.branches = branches;
  }
  
  @Mutation
  private async setCurrentBranch(branch: BranchDto) {
    if (branch) {
      branch.name = branch.brandName;
      branch.isBranch = true;
    }
    this.currentBranch = branch;
    this.currentDesk = null;
  }

  @Mutation
  private async setBranchFromEdit(branch: BranchDto) {
    branch.name = branch.brandName;
    branch.isBranch = true;
    this.currentBranch = branch;
    const index = this.branches.findIndex((findBranch: BranchDto) => branch.id === findBranch.id);
    this.branches.splice(index, 1, branch);
  }

  @Mutation
  private async setBranchFromCreate(branch: BranchDto) {
    branch.name = branch.brandName;
    branch.isBranch = true;
    this.branches.push(branch);
  }

  @Mutation
  private async setLoadingDesks(isLoadingDesks: boolean) {
      this.loadingDesks = isLoadingDesks;
  }

  @Mutation
  private async setDesks(desks: DeskDto[]) {
      this.desks = desks;
      if (desks && desks.length > 0) {
        this.currentDesk = this.desks[0];
      }
  }
  
  @Mutation
  private async setCurrentDesk(desk: DeskDto) {
    console.log(desk);
      this.currentDesk = desk;
  }

  @Mutation
  private async setDeskFromCreate(desk: DeskDto) {
    //We need to add this to the list of desks on the corresponding branch
    const index = this.branches.findIndex((findBranch: BranchDto) => desk.branchId === findBranch.id);
    this.branches[index].desks.push(desk);
  }

  @Mutation
  private async setDeskFromEdit(desk: DeskDto) {
    this.currentDesk = desk;
    const branchIndex = this.branches.findIndex((findBranch: BranchDto) => desk.branchId === findBranch.id);
    const branch = this.branches[branchIndex];
    const deskIndex = branch.desks.findIndex((findDesk: DeskDto) => desk.id === findDesk.id);
    branch.desks.splice(deskIndex, 1, desk);
  }

  @Mutation
  private async setLoadingIndustries(isLoading: boolean) {
      this.loadingIndustries = isLoading;
  }

  @Mutation
  private async setIndustries(industries: IndustryDto[]) {
      this.industries = industries;
      if (industries && industries.length > 0) {
        this.currentIndustry = this.industries[0];
      }
  }

  @Mutation
  private async setCurrentIndustry(industry: IndustryDto) {
      this.currentIndustry = industry;
  }

  @Mutation
  private async setIndustryFromEdit(industry: IndustryDto) {
   this.currentIndustry = industry;
   const index = this.industries.findIndex((findIndustry: IndustryDto) => industry.id === findIndustry.id);
   this.industries.splice(index, 1, industry);
  }

  @Mutation
  private async setIndustryFromCreate(industry: IndustryDto) {
    this.industries.push(industry);
  }

  @Mutation
  private async setLoadingLocationTypes(isLoading: boolean) {
      this.loadingLocationTypes = isLoading;
  }

  @Mutation
  private async setLocationTypes(locationTypes: LocationTypeDto[]) {
      this.locationTypes = locationTypes;
  }

  @Mutation
  private async setCurrentLocationType(locationType: LocationTypeDto) {
      this.currentLocationType = locationType;
  }

  @Mutation
  private async setLocationTypeFromEdit(locationType: LocationTypeDto) {
   this.currentLocationType = locationType;
   const index = this.locationTypes.findIndex((findLocationType: LocationTypeDto) => locationType.id === findLocationType.id);
   this.locationTypes.splice(index, 1, locationType);
  }

  @Mutation
  private async setLocationTypeFromDelete() {
   const index = this.locationTypes.findIndex((findLocationType: LocationTypeDto) => this.currentLocationType.id === findLocationType.id);
   this.locationTypes.splice(index, 1);
   this.currentLocationType = null;
  }

  @Mutation
  private async setLocationTypeFromCreate(locationType: LocationTypeDto) {
    this.locationTypes.push(locationType);
  }

  @Mutation
  private async setLoadingOpportunitySources(isLoading: boolean) {
    this.loadingOpportunitySources = isLoading;
  }

  @Mutation
  private async setOpportunitySources(opportunitySources: OpportunitySourceDto[]) {
    this.opportunitySources = opportunitySources;
  }

  @Mutation
  private async setCurrentOpportunitySource(opportunitySource: OpportunitySourceDto) {
    this.currentOpportunitySource = opportunitySource;
  }

  @Mutation
  private async setOpportunitySourceFromEdit(opportunitySource: OpportunitySourceDto) {
    this.currentOpportunitySource = opportunitySource;
    const index = this.opportunitySources.findIndex((find: OpportunitySourceDto) => opportunitySource.id === find.id);
    this.opportunitySources.splice(index, 1, opportunitySource);
  }

  @Mutation
  private async setOpportunitySourceFromDelete() {
    const index = this.opportunitySources.findIndex((find: OpportunitySourceDto) => this.currentOpportunitySource.id === find.id);
    this.opportunitySources.splice(index, 1);
    this.currentOpportunitySource = null;
  }

  @Mutation
  private async setOpportunitySourceFromCreate(opportunitySource: OpportunitySourceDto) {
    this.opportunitySources.push(opportunitySource);
  }

  @Mutation
  private async setLoadingOpportunityLostReasons(isLoading: boolean) {
    this.loadingOpportunityLostReasons = isLoading;
  }

  @Mutation
  private async setOpportunityLostReasons(opportunityLostReasons: OpportunityLostReasonDto[]) {
    this.opportunityLostReasons = opportunityLostReasons;
  }

  @Mutation
  private async setCurrentOpportunityLostReason(opportunityLostReason: OpportunityLostReasonDto) {
    this.currentOpportunityLostReason = opportunityLostReason;
  }

  @Mutation
  private async setOpportunityLostReasonFromEdit(opportunityLostReason: OpportunityLostReasonDto) {
    this.currentOpportunityLostReason = opportunityLostReason;
    const index = this.opportunityLostReasons.findIndex((find: OpportunityLostReasonDto) => opportunityLostReason.id === find.id);
    this.opportunityLostReasons.splice(index, 1, opportunityLostReason);
  }

  @Mutation
  private async setOpportunityLostReasonFromDelete() {
    const index = this.opportunityLostReasons.findIndex((find: OpportunityLostReasonDto) => this.currentOpportunityLostReason.id === find.id);
    this.opportunityLostReasons.splice(index, 1);
    this.currentOpportunityLostReason = null;
  }

  @Mutation
  private async setOpportunityLostReasonFromCreate(opportunityLostReason: OpportunityLostReasonDto) {
    this.opportunityLostReasons.push(opportunityLostReason);
  }

  @Mutation
  private async setCurrentRateCard(rateCard: RateCardDto) {
      this.currentRateCard = rateCard;
  }

  @Mutation
  private async setLoadingRateCards(isLoading: boolean) {
      this.loadingRateCards = isLoading;
  }

  @Mutation
  private async setRateCards(rateCards: RateCardDto[]) {
      this.rateCards = rateCards;
  }

  @Mutation
  private async setRateCardFromEdit(rateCard: RateCardDto) {
   //Retain the positions as they aren't returned from edit
   rateCard.positions = JSON.parse(JSON.stringify(this.currentRateCard.positions));
   this.currentRateCard = rateCard;
   const index = this.rateCards.findIndex((findRateCard: RateCardDto) => rateCard.id === findRateCard.id);
   this.rateCards.splice(index, 1, rateCard);
  }

  @Mutation
  private async setRateCardFromCreate(rateCard: RateCardDto) {
    this.rateCards.push(rateCard);
  }

  @Mutation
  private async setRateCardPositionFromEdit(rateCardPosition: RateCardPositionDto) {
    const index = this.currentRateCard.positions.findIndex((findRateCardPosition: RateCardPositionDto) => rateCardPosition.id === findRateCardPosition.id);
    this.currentRateCard.positions.splice(index, 1, rateCardPosition);
  }

  @Mutation
  private async setRateCardPositionFromCreate(rateCardPosition: RateCardPositionDto) {
    this.currentRateCard.positions.push(rateCardPosition);
  }

  @Mutation
  private async removeRateCardPositionFromDelete(rateCardPosition: RateCardPositionDto) {
    const rateCardPositionIndex = this.currentRateCard.positions.findIndex((findRateCardPosition: RateCardPositionDto) => rateCardPosition.id === findRateCardPosition.id);
    this.currentRateCard.positions.splice(rateCardPositionIndex, 1);
  }

  @Mutation
  private async setCurrentForm(form: FormDto) {
      this.currentForm = form;
      this.questions = form.questions;
  }

  @Mutation
  private async setLoadingForms(isLoading: boolean) {
      this.loadingForms = isLoading;
  }

  @Mutation
  private async setLoadingForm(isLoading: boolean) {
      this.loadingForm = isLoading;
  }

  @Mutation
  private async setForms(forms: FormDto[]) {
      this.forms = forms;
      if (forms && forms.length > 0) {
        this.currentForm = this.forms[0];
      } else {
        this.currentForm = new FormDto();
      }
  }

  @Mutation
  private async setFormFromEdit(form: FormDto) {
    this.currentForm = form;
    const index = this.forms.findIndex((findForm: FormDto) => form.id === findForm.id);
    this.forms[index] = form;
  }

  @Mutation
  private async setFormFromCreate(form: FormDto) {
    this.forms.push(form);
  }

  @Mutation
  private async setQuestionFromEdit(question: QuestionDto) {
    const index = this.currentForm.questions.findIndex((findQuestion: QuestionDto) => question.id === findQuestion.id);
    this.currentForm.questions.splice(index, 1, question);
  }

  @Mutation
  private async setQuestionFromCreate(question: QuestionDto) {
    this.questions.push(question);
  }

  @Mutation
  private async setCurrentDocumentTemplate(documentTemplate: DocumentTemplateDto) {
      this.currentDocumentTemplate = documentTemplate;
  }

  @Mutation
  private async setLoadingDocumentTemplates(isLoadingDocumentTemplates: boolean) {
      this.loadingDocumentTemplates = isLoadingDocumentTemplates;
  }

  @Mutation
  private async setDocumentTemplates(documentTemplates: DocumentTemplateDto[]) {
      this.documentTemplates = documentTemplates;
      if (documentTemplates && documentTemplates.length > 0) {
        this.currentDocumentTemplate = this.documentTemplates[0];
      }
  }

  @Mutation
  private async setDocumentTemplateHtmlFromEdit(documentTemplate: DocumentTemplateDto) {
    this.currentDocumentTemplate = documentTemplate;
    const index = this.documentTemplates.findIndex((findDocumentTemplate: DocumentTemplateDto) => documentTemplate.id === findDocumentTemplate.id);
    this.documentTemplates[index] = documentTemplate;
  }
}

export const AgencySettingsModule = getModule(AgencySettings)
